import { SvgIcon } from "@mui/material"

import { ReactComponent as CircleDashedAdd } from "./CircleDashedAdd.svg"

export const CircleDashedAddIcon = (props) => {
    return (
        <SvgIcon component={CircleDashedAdd} {...props} inheritViewBox />
    )
}
